import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../config";

export function useProcessShippingCostsBatch() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async (data) => {
            const res = await api.post(`/shipping/shipping-costs/batch`, data);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['shipping-costs-list']);
        }
    });
}

export function useStartShippingCostsExport() {
    return useMutation({
        mutationFn: async (params = {}) => {
            const queryParams = new URLSearchParams();
            
            if (params.weeklyComparison) {
                queryParams.append('weeklyComparison', 'true');
            }
            
            const url = `/shipping/shipping-costs/export/start${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            const res = await api.post(url);
            return res.data;
        }
    });
}

export function useDownloadShippingCostsExportFile() {
    return useMutation({
        mutationFn: async (jobId) => {
            const res = await api.get(`/shipping/shipping-costs/export/download/${jobId}`, {
                responseType: 'blob'
            });
            return res.data;
        }
    });
}

export function useImportShippingCostsFromML() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async () => {
            const res = await api.post(`/shipping/shipping-costs/fetch-user-items`);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['shipping-costs-list']);
        }
    });
}